import './style.css'
import App from './App'

const app = new App()
app.init()